<template>
    <Popup :open="open" @open="this.$emit('update:open', (open = !open))" popupWidth="w-3/4 md:w-3/4 lg:w-1/3" :padding="true">
        <Loading :loading="loading" class="min-h-full">
            <div v-if="!loading">
                <div class="py-4 border-b border-gray-300 w-full">
                    <strong> {{ $t('plain_abonnement') }} - {{ $t('change_runtime') }} </strong>
                </div>
                <div class="mt-4">
                    <div class="py-4">
                        <div class="flex flex-row items-center gap-4">
                            <div class="w-[50px] h-[50px] rounded-md text-white">
                                <img
                                    :alt="$translate(abonnement.product.name)"
                                    class="w-full h-full object-contain"
                                    :src="abonnement.product.image.replace('.png', '-gradient.png')"
                                />
                            </div>
                            <strong>
                                {{ $translate(abonnement.product.name) }}
                            </strong>
                        </div>
                        <div class="mt-4">
                            <strong>
                                {{ $t('current_runtime') }}
                            </strong>
                            <p>
                                {{ $translate(this.getPeriodInProductVariant(abonnement.productVariant).title) }}
                            </p>
                            <p class="mt-2 text-blue text-xs" v-if="selectedRuntime.discount_abonnement">
                                {{ $t('current_update_credit_discount_checkout', { discount: $toCurrency(selectedRuntime.discount_abonnement) }) }}
                            </p>
                        </div>
                    </div>

                    <hr class="w-full border-gray-300 border-b-0.5 my-4" />

                    <div class="py-4">
                        <strong>
                            {{ $t('runtime_new') }}
                        </strong>
                        <Radio
                            name="runtime"
                            v-if="runtimeOptions.length"
                            :formComponentId="this.$.uid"
                            :label="$t('runtime_choose')"
                            v-model:selected="selectedRuntimeId"
                            :options="runtimeOptions"
                            :multiple="false"
                        >
                        </Radio>
                    </div>

                    <hr class="w-full border-gray-300 border-b-0.5 my-4" />

                    <FormButton
                        @click="addRuntimeToCart()"
                        class="mt-3"
                        styling="primary flex items-center gap-3 w-full justify-center"
                        :value="$t('change_runtime')"
                        :disabled="false"
                    >
                    </FormButton>
                </div>
            </div>
        </Loading>
    </Popup>
</template>

<script>
import { mapGetters } from 'vuex';
import Toastification from '../miscellaneous/Toastification.vue';
import i18next from 'i18next';
import _ from 'lodash';

export default {
    data: () => ({
        runtimeOptions: [],
        selectedRuntimeId: null,
        loading: true,
        abonnement: null
    }),

    mounted() {
        this.loading = true;

        this.$store.dispatch('abonnements/show', this.abonnementId).then((response) => {
            this.abonnement = response.data;

            // sort options by runtime
            let sortedProductVariantsForUpgrade = _.sortBy(this.abonnement.productVariantsForUpgrade.data, (productVariant) => {
                let productAttributeValue = productVariant.productAttributeValues.data.find((productAttributeValue) => {
                    return productAttributeValue.meta.type === 'period';
                });
                return productAttributeValue.meta.runtime_in_days;
            });

            // transform options for radio buttons
            sortedProductVariantsForUpgrade.forEach((productVariant) => {
                let frequency = this.getFrequencyInProductVariant(productVariant).title;
                let period = this.getPeriodInProductVariant(productVariant).title;

                this.runtimeOptions.push({
                    label: `${this.$translate(period)} / ${this.$translate(frequency)} <small>(${this.$toCurrency(productVariant.total_end_price_gross)})</small><br><small> ${i18next.t('plain_discount')}: ${this.$toPercent(productVariant.discount_percent)}</small>`,
                    value: productVariant.id,
                    sublabel: productVariant.end_price_gross
                });
            });

            // set the first runtime option as the selected
            this.selectedRuntimeId = this.runtimeOptions[0].value;

            this.loading = false;

            // reload the abonnements in parent component
            this.$parent.indexAbonnements();
        });
    },

    props: ['open', 'abonnementId'],
    emits: ['update:open'],

    watch: {
        open: function () {
            this.$emit('update:open', this.open);
        }
    },
    computed: {
        background() {
            let backgroundColor = this.abonnement?.product?.productGroups.data[0].productCategories.data[0].background_color;
            let backgroundGradient = this.abonnement?.product?.productGroups.data[0].productCategories.data[0].background_gradient;

            return 'linear-gradient(to bottom, ' + backgroundColor + ' 0%, ' + backgroundGradient + ' 100%)';
        },
        ...mapGetters('payment_methods', {
            getPaymentMethods: 'get'
        }),
        ...mapGetters('user', ['isLoggedIn', 'receivesNewsletters', 'hasCustomer']),
        selectedRuntime() {
            return this.abonnement.productVariantsForUpgrade.data.find((productVariant) => productVariant.id === this.selectedRuntimeId);
        }
    },

    methods: {
        getPeriodInProductVariant(productVariant) {
            return productVariant.productAttributeValues.data.find((productAttributeValue) => productAttributeValue.meta.type === 'period');
        },
        getFrequencyInProductVariant(productVariant) {
            return productVariant.productAttributeValues.data.find((productAttributeValue) => productAttributeValue.meta.type === 'frequency');
        },
        addRuntimeToCart() {
            this.$store
                .dispatch('cart_products/store', {
                    product_variant_id: this.selectedRuntimeId
                })
                .then((response) => {
                    // if no message in response the product was added succesfully
                    if (response?.meta?.message) {
                        _.forEach(response?.meta?.message, (message, type) => {
                            this.$toast[type === 'danger' ? 'error' : type]({
                                component: Toastification,
                                props: {
                                    message: message,
                                    type: type === 'danger' ? 'error' : type
                                }
                            });
                        });
                    }

                    if (this.abonnement.userPaymentMethod) {
                        this.$router.push({
                            name: 'checkout',
                            params: {
                                payment_method_id: this.abonnement.userPaymentMethod.id
                            }
                        });
                    } else {
                        this.$router.push({ name: 'checkout' });
                    }
                });
        }
    }
};
</script>

<style scoped>
.icon {
    background: v-bind(background);
}
</style>
